// V2 Bronzium section config — the page the "/player/bronzium/v2" tab embeds.
//
// There is NO new app and NO new token handshake here. The Bronzium opener is a page inside the HotUtilsV2-Player
// app (HotUtilsV2 `docs/design/bronzium-opener.md`), exactly as V2-Datacrons, V2-Player Events, V2-Mods and
// V2-Salvage are. So this module only names the URL; the origin, the enablement gate and the parent-token
// minting all come from utils/v2player.ts unchanged — the same division of labour utils/v2salvage.ts uses.
//
// ⚠️ This tab is ADDITIVE. The legacy Bronzium page (`/player/bronzium`, pages/Dashboard/Bronziums) stays exactly
// where it is; nothing here replaces or hides it.

import { getV2PlayerUrl, isV2PlayerEnabled } from "./v2player";

/**
 * The Player app's Bronzium opener page.
 *
 * 🔴 The path is the whole contract with the embedded app: `App.tsx` there selects the page with
 * `pathname.startsWith('/bronzium')` and FALLS THROUGH TO DATACRONS otherwise. A wrong or dropped path does
 * not fail loudly — the app boots and shows Datacrons, so the tab looks like it simply does not work yet.
 *
 * ⚠️ The parent route and the framed path differ on purpose: `/player/bronzium/v2` here, `/bronzium` there.
 * The embedded app has its own flat path space and knows nothing about where the website filed the tab.
 */
export function getV2BronziumUrl(): string {
  return getV2PlayerUrl() + "/bronzium";
}

/**
 * The V2-Bronzium tab has no gate of its own: it IS the Player app, so it appears exactly where the other
 * Player-app tabs do — development.hotutils.com and localhost today. Named separately so the section's gate is
 * one thing to change on the day it graduates ahead of (or behind) the rest of that app.
 *
 * 🔴 The gate matters here: the page SPENDS the player's Ally Points on their live game account, and there is no
 * refund. Until a live run has been watched on a test account (`maxPacks: 1`), this must not surface anywhere but
 * development.
 *
 * The ROUTE and the MENU ITEM must both use this, or the tab appears where it cannot work.
 */
export function isV2BronziumEnabled(): boolean {
  return isV2PlayerEnabled();
}
